import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M12 7.77L18.39 18H5.61L12 7.77ZM12 4L2 20H22L12 4Z" fill="black"/>
</svg>
;
